import {post} from 'aws-amplify/api';

async function UploadFiles(files, userData, setErrorMessage, setLoadingUpload, setShowSuccess, setFileData, setUploadedFiles) {
    const filesArray = Array.from(files);

    const formData = new FormData();
    filesArray.forEach((file, index) => {
        formData.append(`file`, file);
    });
    Object.keys(userData).forEach((key) => {
        formData.append(key, userData[key]);
    });

    try {
        const restOperation = post({
            apiName: 'Catalytics_STAGING_API',
            path: '/user_upload',
            options: {
                body: formData,
            },
            headers: {
                Accept: 'multipart/form-data',
            }
        });
        const {body} = await restOperation.response;
        const response = await body.json();
        if (!response.status) {
            if (setErrorMessage) {
                setErrorMessage(response.error)
                setLoadingUpload(false)
                setShowSuccess(false)
                setFileData({
                    name: [],
                    landingPages: [],
                    adSizes: [],
                })
                setUploadedFiles([])
            }
            return;
        }
        setShowSuccess(true)
        setFileData({
            name: [],
            landingPages: [],
            adSizes: [],
        })
        setUploadedFiles([])
    } catch (e) {
        console.error('Error uploading files:', e);
        setErrorMessage('An error occurred while uploading files. Please try again.')
        setLoadingUpload(false)
        setShowSuccess(false)
        setFileData({
            name: [],
            landingPages: [],
            adSizes: [],
        })
        setUploadedFiles([])
    }
}

export default UploadFiles;